import Vue from 'vue'
import _ from 'lodash';
import VueAxios from 'vue-axios'
import axios from 'axios';
import {VueAuthenticate} from 'vue-authenticate'

Vue.use(VueAxios, axios)
/* global config */

var top = window.screen.height - 300;
 top = top > 0 ? top/2 : 0;

var left = window.screen.width - 400;
left = left > 0 ? left/2 : 0;

const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
    baseUrl: '/api', // Your API domain
    storageNamespace: 'helios',
    tokenPrefix: 'bifrost',

    providers: {
        google: {
            clientId: config.GOOGLE_CLIENT_ID,
            redirectUri: window.location.origin + '/auth/google/callback',
            popupOptions: { width: 452, height: 633, top: top, left: left }
            // scope:
        }
    },

})


Vue.use(vueAuth)


// You can use it as state property
const state = () => ({
    isAuthenticated: vueAuth.isAuthenticated(),
    user: null,
    permissions: null,
    roles: null,
    token: ''
})

// You can use it as a state getter function (probably the best solution)
const getters = {
    isAuthenticated(state) {
        return state.isAuthenticated
    },
    getUser(state) {
        return state.user
    },
    getToken() {
        return state.token
    },
    hasPermission: (state) => (permissionName) => {
        if(!state.user || !state.permissions) return false
        return _.findKey(state.permissions, {name: permissionName}) !== undefined;
    },
    hasRole: (state) => (roleName) => {
        if(!state.user || !state.roles) return false
        return _.findKey(state.roles, {name: roleName}) !== undefined;
    }
}

// Mutation for when you use it as state property
const mutations = {
    isAuthenticated(state, payload) {
        state.isAuthenticated = payload.isAuthenticated
    },
    updateUser(state, payload) {
        state.user = payload.users
        if(payload.roles){
            state.roles = payload.roles
        }
        if(payload.roles) {
            state.permissions = payload.permissions
        }
    },
    setToken(state, payload) {
        state.token = payload.token
    }
}
const actions = {

    // Perform VueAuthenticate login using Vuex actions
    loginGoogle({dispatch, commit}) {
        return new Promise((resolve, reject) => {
                console.log(vueAuth);

                vueAuth.authenticate('google').then(function () {
                    commit('isAuthenticated', {
                        isAuthenticated: vueAuth.isAuthenticated()
                    })
                    dispatch('loadUser')
                    resolve()
                }).catch((err) => {
                    reject()
                    console.log(err);
                });
            }
            , 1000)
    },

    loginPassword({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
                const formData = new FormData()
                formData.append('grant_type', 'password')
                formData.append('username', payload.username)
                formData.append('password', payload.password)

                axios.post('/api/token', formData)
                    .then((res) => {

                        if (res.data.access_token) {
                            localStorage.setItem('helios.bifrost_token', res.data.access_token)
                            commit('isAuthenticated', {
                                isAuthenticated: true
                            })
                            dispatch('loadUser')
                            resolve()
                        }
                    }).catch((err) => {
                    reject(err)
                    console.log(err);
                })

            }
            , 1000)
    },

    logout({commit}) {
        localStorage.removeItem('helios.bifrost_token')
        commit('isAuthenticated', {
            isAuthenticated: false
        })
        commit('setToken', {
            token: ''
        })
        commit('updateUser', {
            user: null
        })
    },

    checkLogin({dispatch, commit, state}) {
        if (state.isAuthenticated && state.user === null) {
            commit('setToken', {
                token: vueAuth.getToken()
            })
            dispatch('loadUser')
        }
    },

    loadUser({commit}) {
        return new Promise((resolve, reject) => {
                axios.get('/api/users/me')
                    .then((res) => {
                        console.log(res)
                        commit('updateUser', res.data)
                        resolve()
                    }).catch((err) => {
                    reject()
                    console.log(err);
                })
            }
            , 1000)
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}